import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { MenuIcon, XIcon } from "lucide-react";
import { Logo } from "./Logo";
import { navLinks } from "../data/site";
export function Header() {
  const [open, setOpen] = useState(false);
  return <header className="relative z-20" data-id="element-60" data-mp="2nlbtcxlihhkj">
      <div className="flex items-center justify-between rounded-full bg-cream px-5 py-3 shadow-[0_8px_30px_rgba(15,42,68,0.08)] md:px-7 md:py-4" data-id="element-61" data-mp="2ni7kvo10jzo2">
        <Logo data-id="element-62" data-mp="2wk72ahfxx5rj" />
        <nav aria-label="Navigation principale" className="hidden lg:block" data-id="element-63" data-mp="2wjntprc6jtq6">
          <ul className="flex items-center gap-1" data-id="element-64" data-mp="31d05h0vrg61i">
            {navLinks.map((link, i) => <li key={link.to} className="flex items-center" data-id="element-65" data-mp="36bbg3dtvqkks" data-mpi={i}>
                {i > 0 && <span className="mx-2 h-1 w-1 rounded-full bg-navy/30" aria-hidden="true" data-id="element-66" data-mp="3baelizdrusta" />}
                <NavLink to={link.to} className={({
              isActive
            }) => `whitespace-nowrap rounded-full px-2 py-1 text-[15px] transition-colors duration-150 hover:text-wing ${isActive ? "text-wing" : "text-navy"}`} data-id="element-67" data-mp="3fbq3qjubgbrg">
                  {link.label}
                </NavLink>
              </li>)}
          </ul>
        </nav>
        <Link to="/participer" className="hidden whitespace-nowrap rounded-full bg-red px-6 py-2.5 text-[15px] font-semibold text-white transition-colors duration-150 hover:bg-red-deep lg:inline-block" data-id="element-68" data-mp="2ho3l2f5p5xe1">
          Devenir bénévole
        </Link>
        <button type="button" onClick={() => setOpen(v => !v)} className="rounded-full p-2 text-navy lg:hidden" aria-label={open ? "Fermer le menu" : "Ouvrir le menu"} aria-expanded={open} data-id="element-69" data-mp="35lj35wfplxmv">
          {open ? <XIcon className="h-6 w-6" data-id="element-70" data-mp="1y0leh4du1ws" /> : <MenuIcon className="h-6 w-6" data-id="element-71" data-mp="1yaeidkq4p6p" />}
        </button>
      </div>

      <AnimatePresence data-id="element-72" data-mp="3t9k86vdoivxj">
        {open && <motion.nav aria-label="Navigation mobile" initial={{
        opacity: 0,
        y: -8,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -8,
        scale: 0.98
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute inset-x-0 top-full mt-2 rounded-3xl bg-cream p-4 shadow-xl lg:hidden" data-id="element-73" data-mp="1rdtgm8z6ynap">
            <ul className="flex flex-col" data-id="element-74" data-mp="18mk4rt1y7mfy">
              {navLinks.map(link => <li key={link.to} data-id="element-75" data-mp="1cof6gynsk1u9">
                  <NavLink to={link.to} onClick={() => setOpen(false)} className="block rounded-2xl px-4 py-3 text-lg text-navy hover:bg-sand" data-id="element-76" data-mp="1cpgh520wambg">
                    {link.label}
                  </NavLink>
                </li>)}
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}